module.exports = __webpack_public_path__ + "static/media/fotoNoTrobada.4896fbd6.jpg";